import { render } from "./PendingRiders.vue?vue&type=template&id=d94e5a4c&scoped=true"
import script from "./PendingRiders.vue?vue&type=script&lang=js"
export * from "./PendingRiders.vue?vue&type=script&lang=js"

import "./PendingRiders.vue?vue&type=style&index=0&id=d94e5a4c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94e5a4c"]])

export default __exports__